<p-confirmdialog />
<p-toast />
<div class="px-1 py-2 surface-ground md:px-1 lg:px-2">
  <block-ui>
    <div *ngIf="this.iAmLoading">
      <h2>Getting your information ....</h2>
    </div>
    <div *ngIf="!this.iAmLoading">
      <section class="px-6 py-1 surface-section">
        <app-latest-invoice-payment (paymentProcessed)="handleData(true)"
          [customer_overview]="customer_overview"></app-latest-invoice-payment>
          <app-payment-methods [customer]="customer_overview()"></app-payment-methods>
          <app-payment-history
          [customer_overview]="customer_overview"></app-payment-history>
      </section>
    </div>
  </block-ui>
</div>
